module.exports = "<div class=\"wrapper theme-2-active pimary-color-blue\">\r\n    <app-header></app-header>\r\n    <app-sidebar></app-sidebar>\r\n    <div class=\"page-wrapper\">\r\n        <router-outlet></router-outlet>\r\n        <app-footer></app-footer>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/emrsidebar/emrsidebar.component.html
// module id = ../../../../../src/app/emrsidebar/emrsidebar.component.html
// module chunks = main